import { FC, useEffect } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'

import Preloader from '../../components/Preloader'
import { TGetLinkedinAuthorizationLinkPayload } from '../../store/project/types'
import { getLinkedinAuthorizationLinkThunk } from '../../store/project/thunks'

import { useDispatch, useSelector } from '../../store/index'

import './ConnectSocialAccounts.scss'

interface ICallBack {}

const FacebookCallBack: FC<ICallBack> = () => {
  const dispatch = useDispatch()
  const { currentProjectId } = useSelector(({ project: { currentProject } }) => ({
    currentProjectId: currentProject.id
  }))

  useEffect(() => {
    if (currentProjectId) {
      loginLinkedin()
    }
  }, [currentProjectId])

  const loginLinkedin = async () => {
    if (currentProjectId) {
      try {
        const payload: TGetLinkedinAuthorizationLinkPayload = {
          callback_url: `${window.location.origin}/linkedin/callback`,
          project_id: currentProjectId
        }

        const responseGetLinkedinAuthorizationLink = await dispatch(
          getLinkedinAuthorizationLinkThunk(payload)
        )

        if (isFulfilled(responseGetLinkedinAuthorizationLink)) {
          const {
            payload: {
              data: { authorization_link: authorizationLink }
            }
          } = responseGetLinkedinAuthorizationLink

          window.open(authorizationLink, '_self')
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  return (
    <div className='page-container'>
      <Preloader />
    </div>
  )
}

export default FacebookCallBack
